import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button as MuiButton, Typography, Box, TextField, Stack, Rating } from '@mui/material';
import RateReviewIcon from '@mui/icons-material/RateReview';

export default function FeedbackPopup({ open, onClose, onSubmit, loading, theme }) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');

  const handleRatingChange = (event, newValue) => {
    setRating(newValue);
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const handleSubmit = () => {
    onSubmit({ rating, feedback });
  };

  const handleClose = () => {
    setRating(0);
    setFeedback('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{
        background: theme.palette.primary.main,
        color: '#fff',
        fontWeight: 700,
        letterSpacing: 0.5,
        textAlign: 'center',
        pb: 2,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <RateReviewIcon sx={{ color: '#fff', fontSize: 28 }} />
          <span>Write a review</span>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ background: '#fff', borderBottomLeftRadius: 8, borderBottomRightRadius: 8, p: 5, minHeight: 220, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ maxWidth: 500, width: '100%' }}>
          <Stack spacing={3}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                Star Review
              </Typography>
              <Rating
                name="star-rating"
                value={rating}
                onChange={handleRatingChange}
                size="large"
              />
            </Box>
            <TextField
              label="Feedback"
              multiline
              minRows={4}
              fullWidth
              value={feedback}
              onChange={handleFeedbackChange}
              variant="outlined"
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', background: '#fff', borderBottomLeftRadius: 8, borderBottomRightRadius: 8, pb: 2 }}>
        <MuiButton
          onClick={handleClose}
          variant="outlined"
          color="primary"
          sx={{
            minWidth: 100,
            fontWeight: 600,
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            background: '#fff',
            '&:hover': {
              background: theme.palette.primary.light,
              borderColor: theme.palette.primary.dark,
              color: theme.palette.primary.dark,
            },
            mr: 2
          }}
        >
          Cancel
        </MuiButton>
        <MuiButton
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading || !rating || !feedback.trim()}
          sx={{
            minWidth: 140,
            fontWeight: 700,
            background: theme.palette.primary.main,
            color: '#fff',
            boxShadow: '0 2px 8px 0 rgba(33, 150, 243, 0.15)',
            '&:hover': {
              background: theme.palette.primary.dark,
              color: '#fff',
            },
          }}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
}
